import {Action} from '../../../../../common/types/common';
import {SalesforceDTO} from '../../../common/types/epics';
import {SalesforceCommissionPaymentDTO} from '../../../../chats/types/reducers';

export const GOT_SALESFORCE_DATA_STEP_STATE_ACTION: Action = {
    name: 'GOT_SALESFORCE_DATA_STEP_STATE_ACTION',
    action: (salesforce: SalesforceDTO) => ({
        salesforce,
        type: GOT_SALESFORCE_DATA_STEP_STATE_ACTION.name
    })
};

export const SALESFORCE_CANCEL_ACTION: Action = {
    name: 'SALESFORCE_CANCEL_ACTION',
    action: () => ({
        type: SALESFORCE_CANCEL_ACTION.name
    })
};

export const SALESFORCE_CANCELLED_ACTION: Action = {
    name: 'SALESFORCE_CANCELLED_ACTION',
    action: () => ({
        type: SALESFORCE_CANCELLED_ACTION.name
    })
};


export const GOT_SALESFORCE_COMMISSION_PAYMENT_STATUS_ACCOUNT: Action = {
    name: 'GOT_SALESFORCE_COMMISSION_PAYMENT_STATUS_ACCOUNT',
    action: (salesforceCommissionPayment: SalesforceCommissionPaymentDTO) => ({
        salesforceCommissionPayment,
        type: GOT_SALESFORCE_COMMISSION_PAYMENT_STATUS_ACCOUNT.name
    })
};
